<!--
 * @Author: scg
 * @Date: 2022-01-06 21:32:42
 * @LastEditTime: 2022-02-25 11:12:48
 * @LastEditors: scg
 * @Description:
-->
<template>
  <div class="fff">
    <div class="Keylogger">
      <div class="div">{{$t('keylogger.appName')}}</div>
      <el-select @change="getlist()" class="countrys" v-model="key.pkg">
        <el-option :label="$t('All')" :value="0"></el-option>
        <el-option
          :label="val.name"
          :value="val.id"
          v-for="(val, key) in applist"
          :key="key"
        ></el-option>
      </el-select>
      <!-- <select id="country" name="country">
      <option value="au">Australia</option>
      <option value="ca">Canada</option>
      <option value="usa">USA</option>
    </select> -->
    </div>
    <table class="mytable">
      <tr>
        <th style="width: 260px;">{{$t('keylogger.appName')}}</th>
        <th>{{$t('keylogger.logged')}}</th>
        <th style="width: 200px;">{{$t('keylogger.time')}}</th>
      </tr>
      <tr v-for="(val, key) in list" :key="key">
        <td style="width: 260px;">{{ val.app_name1 ? val.app_name1 : val.name }}</td>
        <td>{{ val.content }}</td>
        <td style="width: 200px;">{{ val.time_show }}</td>
      </tr>
    </table>

    <div class="noData" v-if="list.length <= 0 && status">
      {{$t('keylogger.no')}}
    </div>
    <div class="pagination" v-if="code > 0">
      <el-pagination
        @current-change="setPage"
        background
        layout="prev, pager, next"
        :total="code"
        page-size="20"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import { KeyLogger, App, AllApp } from "@/api/user";
export default {
  name: "HelloWorld",
  data() {
    return {
      key: {
        equipment_id: localStorage.getItem("systemId"),
        pkg: 0,
        page: 1,
        limit: 20,
      },
      value: 1,
      list: [],
      applist: [],
      msg: "",
      appkey: {
        equipment_id: localStorage.getItem("systemId"),
        page: 1,
        limit: 9999,
      },
      status: false,
    };
  },
  mounted() {
    this.getlist();
    AllApp(this.appkey).then((adj) => {
      this.applist = adj.data.list;
    });
  },
  methods: {
    setPage(e) {
      this.key.page = e;
      this.getlist();
    },
    getlist() {
      this.list = [];
      this.status = false;
      KeyLogger(this.key).then((adj) => {
        this.list = adj.data.list;
        this.code = adj.data.count;
        this.status = true;
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.fff {
  width: 97%;
  margin: 20px auto;
  background: #fff;
  border-radius: 12px;
  -webkit-box-shadow: 0 4px 12px -4px rgba(122, 138, 153, 0.2);
  box-shadow: 0 4px 12px -4px rgba(122, 138, 153, 0.2);
  overflow: hidden;
}
.Keylogger {
  padding: 20px 0;
  height: 36px;
  margin-left: 2.75%;
}
.Keylogger .div {
  float: left;
  font-size: 13px;
  color: #45484d;
  letter-spacing: 0;
  height: 36px;
  line-height: 36px;
}
#country {
  float: left;
  width: 230px;
  height: 34px;
  background: #f6f8fa;
  border: 1px solid #d5d7db;
  border-radius: 8px;
  margin-left: 10px;
  padding: 0 10px;
  font-size: 13px;
  color: #000927;
}
.mytable tr td{
  /* text-indent: 60px; */
  /* padding-left: 60px; */
}
.mytable tr th{
  /* padding-left: 60px; */
}
.pop_ul {
  float: left;
  /* width: 385px; */
  width: 419px;
  border-right: 1px solid #e1e3e6;
  background: #fff;
  right: 0;
}
</style>
<style>
.countrys {
  margin-left: 10px;
  background: #f6f8fa;
  float: left;
  width: 230px;
  height: 34px;
  border-radius: 8px;
}
.countrys .el-input__inner {
  background: none;
  height: 34px;
  border-radius: 8px;
}
.el-select.countrys > .el-input {
  height: 34px;
}
.countrys .el-input__icon {
  line-height: 34px;
}
</style>



// WEBPACK FOOTER //
// src/components/Keylogger.vue